import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit,} from '@angular/core';
import { find, get, isEmpty } from 'lodash';
import { AgregationService, BundleCall } from '@ispm-client/modules/aggregator/services';
import { ConfigurationStoreHandler } from '../../../../configuration/services/configuration-store-handler.service';
import { WorklistService } from '../../../services/worklist.service';
import { TablelistStoreHandlerService } from '../../../services/tablelist-store-handler.service';
import { TablelistService } from '../../../services/tablelist.service';
import { Observable, zip } from 'rxjs';
import { first,take, filter } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { StringUtils } from '@ispm/shared/utils/String.utils';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'ispm-dashboard-tab',
  templateUrl: './dashboard-tab.component.html',
  styleUrls: ['./dashboard-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DashboardTabComponent implements OnInit {

  workList: any;
  currentTab: any;
  workListTabDetails: any = [];
  workListTemplateDetails: any = [];
  loading: boolean = false;
  private organizationConfig: Observable<any>;
  private orgId: any;
  private default: String = 'DEFAULT';
  public disclaimerMessage: String = '';
  public dashboardConfig;

  set widgetConfig(widgetConfig) {
  }

  set widgetData(widgetData: any) {
  }

  constructor(
    private _agregationService: AgregationService,
    private _bundleCall: BundleCall,
    private _configurationStoreHandler: ConfigurationStoreHandler,
    private _worklistService: WorklistService,
    private _tablelistStoreHandler: TablelistStoreHandlerService,
    private _tableListService: TablelistService,
    private _store: Store<IgenomicsState>,
    private authService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef) {
      this.organizationConfig = _store.select('users', 'organizationConfiguration');
  }

  ngOnInit() {
    this.workListTemplatesDetails();
    const currentApp = JSON.parse(sessionStorage.getItem('currentApplication'));

    if (currentApp && currentApp.id && this.dashboardConfig === 'insights') {
      this._worklistService.getDisclaimer(this.orgId, currentApp.id)
        .pipe(first())
        .subscribe(msg => {
          this.disclaimerMessage = msg?.text;
        });
    }
  }

  async workListTemplatesDetails() {
    let tabConfigDataBindings: Array<any> = [];
    let resourceType: string = 'AdditionalConfiguration';
    this.dashboardConfig = this.activatedRoute.snapshot.data['dashboardConfig'];
    let resourceName: string = this.dashboardConfig;
    // Support different resource types and names for tabs configuration.
    // By default, tabs configuration is taken from 'AdditionalConfiguration' resource and the resource name is passed in _dashboardConfig.
    // If appConfiguration contains other resource type\name it will be in use.
    const appConfig = JSON.parse(sessionStorage.getItem('currentApplication')); // Getting current app configuration
    if (appConfig && appConfig.items && Array.isArray(appConfig.items)) {
        for (const item of appConfig.items) {
          // Going over all tabs configuration URL's and looking for the related configuration according to the resource name which is at the end of the url.
          // There are two possible formats for this:
          // redirectUrl: "/dashboard/tabs/lungScreening?appname=lcs" - here 'lungScreening' is the resource name
          // redirectUrl: /dashboard/tabs/insights" - here 'insights' is the resource name
          const url: string = item.redirectUrl;
          if (url && (url.endsWith('/' + resourceName) || url.includes('/' + resourceName + '?'))) {
            if (item.tabsResourceType) {
              resourceType = item.tabsResourceType;
            }
            if (item.tabsResourceName) {
              resourceName = item.tabsResourceName;
            }
            break;
          }
      }
    }
    this.organizationConfig.pipe(
      filter(data => !isEmpty(data)),
      take(1)
    ).subscribe(orgConfig => {
      this.orgId = orgConfig.id;
    });
    tabConfigDataBindings.push({
      // "queryString": `_id=${this._dashboardConfig}`,
      // "targetResource": "AdditionalConfiguration"
      'queryString': `name=${resourceName}&context=${this.default},${this.orgId}`,
      'targetResource': resourceType
    });
    const configName = this._worklistService.cacheConfig.get(tabConfigDataBindings[0].queryString);
    if (configName) {
     this._configurationStoreHandler.getConfigById(resourceType, configName).take(1).subscribe(configs => {
       this.workListTabDetails = configs['tabs'];
       const templatePromises = [];
       this.workListTabDetails.forEach((worklistType) => {
         templatePromises.push(
           this._tablelistStoreHandler.resolveConfigurationTemplate(
             Object.assign({ }, worklistType, { configTemplateType: worklistType['worklistType']})
           )
           .filter(template => isEmpty(template['config']))
           .toPromise()
         );
       });
       // Using promise as not expecting templates changed in the client
       Promise.all(templatePromises).then(templates => {
         this.workListTemplateDetails = templates;
         this.currentTab = this.workListTabDetails[0];
         this.workList = find(this.workListTemplateDetails, { 'type': this.currentTab.worklistType});
         this.loading = true;
         this.cdr.detectChanges();
       });
     });
  } else {
      // Already interpolated at the top
    //tabConfigDataBindings = await this._agregationService.interPolateWithStoreQueries(tabConfigDataBindings).toPromise();
      this._bundleCall.searchCall({ queries: tabConfigDataBindings}).subscribe(data => {
        let configidx: string = '0';
        // If there are more than 1 result (could happen when there is a default and an extension), looking for the extension
        if (data[0].response.entry && Array.isArray(data[0].response.entry)) {
          const entriesArr: any[] = data[0].response.entry;
          if (entriesArr.length > 1) {
             const inx: number = entriesArr.findIndex(item => item.resource && item.resource.extends);
             if (inx > -1) {
              configidx = inx.toString();
             }
          }
        }
        const config = get(data[0], ['response', 'entry', configidx, 'resource']);
        this.workListTabDetails = get(data[0], ['response', 'entry', configidx, 'resource', 'tabs']);
        if (this.workListTabDetails && this.workListTabDetails.length > 0) {
          this._configurationStoreHandler.setConfiguration(config);
          this._worklistService.cacheConfig.set(tabConfigDataBindings[0].queryString, config.id);
          const getTemplatePromise = [];
          this.workListTabDetails.forEach((x) => {
            const resourceType = get(x, 'resourceType', 'generic');
            getTemplatePromise.push(this._tableListService.loadConfigTemplate(resourceType, x.worklistType));
          });
          zip(...getTemplatePromise).subscribe(worklistTemplates => {
            worklistTemplates.forEach((worklistTemplate) => {
              this.workListTemplateDetails.push(worklistTemplate);
              const worklistTemplateStore = {
                configTemplateType: get(worklistTemplate, 'type'),
                item: worklistTemplate,
                resourceType: get(worklistTemplate, 'resourceTypeCode', 'generic')
               };
              this._tablelistStoreHandler.addWorklistTempleteToStore(worklistTemplateStore);

              if (
                this.workListTabDetails.length > 0 && this.workListTemplateDetails.length > 0 &&
                (this.workListTabDetails.length === this.workListTemplateDetails.length
              )) {
                this.currentTab = this.workListTabDetails[0];
                this.workList = find(this.workListTemplateDetails, { 'type': this.currentTab.worklistType});
                this.loading = true;
                this.cdr.detectChanges();
              }
           });
          });
        }
        });
       }
     }

  onTabChange(tabTitle, resetSearch: boolean = false) {
    const activeWorkListType = find(this.workListTabDetails, { 'name': tabTitle });
    const activeDetails = activeWorkListType.worklistType;
    this.workList = find(this.workListTemplateDetails, { 'type': activeDetails });
    this.currentTab = activeWorkListType;
    this.loading = true;
    this.cdr.detectChanges();
    if (resetSearch) {
      this.authService.updateLocalSettings('worklistSearchText', '');
      this.authService.updateLocalSettings('worklistSearchResource', '');
    }
    sessionStorage.removeItem('tableState');
  }

  cssClassFormat(className: string) {
    return StringUtils.cssClassFormat(className);
  }

}
